import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

export const api = {
  // auth
  login: (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data),
  logout: () => client.post("/auth/logout").then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  forgotPassword: (email, origin_url) => client.post("/auth/forgot-password", { email, origin_url }).then((r) => r.data),
  resetPassword: (token, new_password) => client.post("/auth/reset-password", { token, new_password }).then((r) => r.data),
  // catalog
  stats: () => client.get("/stats").then((r) => r.data),
  products: (params) => client.get("/products", { params }).then((r) => r.data),
  featured: () => client.get("/products/featured").then((r) => r.data),
  bundles: () => client.get("/bundles").then((r) => r.data),
  product: (id) => client.get(`/products/${id}`).then((r) => r.data),
  pricing: (id) => client.get(`/products/${id}/pricing`).then((r) => r.data),
  livePricing: () => client.get("/pricing/live").then((r) => r.data),
  // admin products
  createProduct: (body) => client.post("/admin/products", body).then((r) => r.data),
  updateProduct: (id, body) => client.put(`/admin/products/${id}`, body).then((r) => r.data),
  deleteProduct: (id) => client.delete(`/admin/products/${id}`).then((r) => r.data),
  publishProduct: (id) => client.post(`/admin/products/${id}/publish`).then((r) => r.data),
  // social
  socialPosts: (platform) => client.get("/social/posts", { params: { platform } }).then((r) => r.data),
  generateSocial: (id) => client.post(`/social/generate/${id}`).then((r) => r.data),
  markPosted: (id) => client.post(`/social/posts/${id}/mark-posted`).then((r) => r.data),
  // email
  subscribe: (email, source) => client.post("/subscribers", { email, source }).then((r) => r.data),
  subscribers: () => client.get("/subscribers").then((r) => r.data),
  digest: () => client.get("/digest/preview").then((r) => r.data),
  sendDigest: () => client.post("/digest/send").then((r) => r.data),
  // admin: sales, promos, settings
  sales: () => client.get("/admin/sales").then((r) => r.data),
  promos: () => client.get("/admin/promos").then((r) => r.data),
  createPromo: (code, percent_off) => client.post("/admin/promos", { code, percent_off }).then((r) => r.data),
  deletePromo: (id) => client.delete(`/admin/promos/${id}`).then((r) => r.data),
  updateCredentials: (body) => client.put("/admin/credentials", body).then((r) => r.data),
  // payments
  checkout: (product_id, origin_url, ref_code, reward_code) => client.post("/payments/checkout", { product_id, origin_url, ref_code, reward_code }).then((r) => r.data),
  checkoutBundle: (bundle_id, origin_url, ref_code, reward_code) => client.post("/payments/checkout-bundle", { bundle_id, origin_url, ref_code, reward_code }).then((r) => r.data),
  paymentStatus: (session_id) => client.get(`/payments/status/${session_id}`).then((r) => r.data),
  // purchase library
  purchases: (email) => client.get("/purchases", { params: { email } }).then((r) => r.data),
  downloadUrl: (session_id) => `${API}/download/${session_id}`,
  watchAlerts: (email, product_ids, origin_url) => client.post("/watch-alerts", { email, product_ids, origin_url }).then((r) => r.data),
  // reviews
  reviews: (product_id) => client.get(`/reviews/${product_id}`).then((r) => r.data),
  createReview: (body) => client.post("/reviews", body).then((r) => r.data),
  // referrals
  createReferral: (email) => client.post("/referrals", { email }).then((r) => r.data),
  referralStats: (email) => client.get(`/referrals/stats/${encodeURIComponent(email)}`).then((r) => r.data),
  validateReferral: (code, track = false) => client.get(`/referrals/${code}`, { params: { track } }).then((r) => r.data),
  referralLeaderboard: () => client.get("/referrals/leaderboard").then((r) => r.data),
  redeemReferral: (email) => client.post("/referrals/redeem", { email }).then((r) => r.data),
  referralWallet: (email) => client.get(`/referrals/wallet/${encodeURIComponent(email)}`).then((r) => r.data),
};

export const getRef = () => {
  try { return localStorage.getItem("tt_ref") || undefined; } catch { return undefined; }
};

export const getReward = () => {
  try { return localStorage.getItem("tt_reward_code") || undefined; } catch { return undefined; }
};

export const clearReward = () => {
  try { localStorage.removeItem("tt_reward_code"); localStorage.removeItem("tt_reward_amt"); } catch { /* noop */ }
};

export default api;
